const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value, key)

const isObject = value => value && typeof value === 'object' && !Array.isArray(value)

const isAsyncToolResult = value => isObject(value) &&
  hasOwn(value, 'output') &&
  (hasOwn(value, 'completed') || hasOwn(value, 'running') || hasOwn(value, 'failed') || hasOwn(value, 'cancelled')) &&
  (hasOwn(value, 'tool') || hasOwn(value, 'operation') || hasOwn(value, 'status'))

const parseJsonTransportValue = value => {
  let parsed = value
  for (let depth = 0; depth < 3 && typeof parsed === 'string'; depth += 1) {
    try {
      parsed = JSON.parse(parsed)
    } catch (_err) {
      break
    }
  }
  return parsed
}

const parseRawToolResultContent = message => {
  if (!message || message.content === undefined || message.content === null) return null
  return parseJsonTransportValue(message.content)
}

const parseToolResultContent = message => {
  let parsed = parseRawToolResultContent(message)
  for (let depth = 0; depth < 3 && isAsyncToolResult(parsed); depth += 1) {
    parsed = parseJsonTransportValue(parsed.output)
  }
  return parsed
}

const decodeJsonStringPrefix = value => {
  let result = ''
  let escaped = false
  for (let index = 0; index < value.length; index += 1) {
    const char = value[index]
    if (escaped) {
      if (char === 'n') result += '\n'
      else if (char === 'r') result += '\r'
      else if (char === 't') result += '\t'
      else if (char === 'b') result += '\b'
      else if (char === 'f') result += '\f'
      else if (char === 'u' && index + 4 < value.length) {
        const code = parseInt(value.slice(index + 1, index + 5), 16)
        if (Number.isFinite(code)) {
          result += String.fromCharCode(code)
          index += 4
        } else {
          result += char
        }
      } else {
        result += char
      }
      escaped = false
    } else if (char === '\\') {
      escaped = true
    } else if (char === '"') {
      break
    } else {
      result += char
    }
  }
  return result
}

const extractReadFileContentPrefix = value => {
  const text = String(value || '')
  const match = /"output"\s*:\s*\{[\s\S]*?"content"\s*:\s*"/.exec(text)
  if (!match) return null
  return decodeJsonStringPrefix(text.slice(match.index + match[0].length))
}

const textFromFileResult = result => {
  if (result === undefined || result === null) return ''
  if (typeof result === 'string') {
    const parsed = parseJsonTransportValue(result)
    if (parsed !== result && isAsyncToolResult(parsed)) {
      return textFromFileResult(parsed.output)
    }
    return result
  }
  if (Array.isArray(result)) {
    return result.map(part => {
      if (part === undefined || part === null) return ''
      if (typeof part === 'string') return part
      return part.text || part.content || ''
    }).join('')
  }
  if (typeof result.content === 'string' || Array.isArray(result.content)) {
    return textFromFileResult(result.content)
  }
  if (typeof result.value === 'string') return result.value
  if (result.output !== undefined) return textFromFileResult(result.output)
  return ''
}

const fileTextFromToolMessage = message => {
  const parsed = parseToolResultContent(message)
  const parsedText = textFromFileResult(parsed)
  if (parsedText !== String(message && message.content || '')) return parsedText
  const prefix = extractReadFileContentPrefix(message && message.content)
  return prefix === null ? parsedText : prefix
}

const isStoredToolResultPartial = message => {
  if (!message || !message.storage || !message.contentLength) return false
  const contentLength = Number(message.contentLength)
  return Number.isFinite(contentLength) && String(message.content || '').length < contentLength
}

module.exports = {
  isAsyncToolResult,
  parseRawToolResultContent,
  parseToolResultContent,
  textFromFileResult,
  fileTextFromToolMessage,
  extractReadFileContentPrefix,
  isStoredToolResultPartial
}
